import {Component, forwardRef, Input} from '@angular/core';
import {AbstractControl, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from '@angular/forms';

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LfsaInputComponent),
  multi: true
};

@Component({
  selector: 'app-lfsa-input',
  templateUrl: './lfsa-input.component.html',
  styleUrls: ['./lfsa-input.component.css'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR]
})
export class LfsaInputComponent implements ControlValueAccessor {

  @Input() placeholder?: string;
  @Input() label: string;
  @Input() control: any;
  @Input() isReadOnly:any = false;
  @Input() type = 'text';
  @Input() addon: boolean = true;
  @Input() id: string;
  @Input() claseLabel = '';

  @Input() mostrarImg = false;
  @Input() rutaImagen: string = '';

  @Input() dateMin?: string;
  @Input() dateMax?: string;
  @Input() groupIcon: boolean = true;
  @Input() autocomplete: boolean = false;
  private innerValue: any;

  @Input() mostrarMjsError = true;

  constructor() {
    if (!this.placeholder) {
      this.placeholder = '';
    }
  }

  get value() {
    return this.innerValue;
  }

  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCb(v);
    }
  }

  onChangeCb: (_: any) => void = () => {
  };
  onTouchedCb: (_: any) => void = () => {
  };

  writeValue(v: any): void {
    this.value = v;
  }

  registerOnChange(fn: any): void {
    this.onChangeCb = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCb = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isReadOnly = isDisabled;
  }
}
